import React, { useEffect } from 'react';
import AnimatedNumber from 'react-animated-number';
import { useQuery } from '@apollo/react-hooks';

import { GEMS_QUERY } from '../services/graphql';

const BoomerBucks = ({ client }) => {
    const { data, error } = useQuery(GEMS_QUERY);


    if (error) {
        return <span>{error.message}</span>
    }

    if (data && (data.currentStudent.availableGems || data.currentStudent.availableGems === 0)) {
        return <AnimatedNumber
            duration={500}
            stepPrecision={0}
            value={data.currentStudent.availableGems}
        />
    }
    return null;
};

export default BoomerBucks;
